<template>
  <el-dialog
    ref="dialog"
    v-dialogDrag
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    class="data_list_dialog"
    width="1200px"
    :before-close="modalClose"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    @open="handleOpen('dialog')"
  >
    <div class="container-box">
      <!-- 查询条件 -->
      <div
        ref="searchCondition"
        class="search-condition"
      >
        <el-row :gutter="10">
          <el-col style="width:60px;padding-left:10px;">
            <el-button
              type="text"
              style=""
            >
              查询条件：
            </el-button>
          </el-col>
          <el-col :span="4">
            <el-input
              v-model="tableList.tableQuery.search.projectNo"
              placeholder="请输入项目编号"
              style="width:100%"
              clearable
              @keyup.enter.native="loadTableData"
            />
          </el-col>
          <el-col :span="4">
            <el-input
              v-model="tableList.tableQuery.search.projectName"
              placeholder="请输入项目名称"
              style="width:100%"
              clearable
              @keyup.enter.native="loadTableData"
            />
          </el-col>
          <el-col :span="4">
            <el-input
              v-model="tableList.tableQuery.search.paymentUnitName"
              placeholder="请输入付款单位名称"
              style="width:100%"
              clearable
              @keyup.enter.native="loadTableData"
            />
          </el-col>
          <el-col :span="4">
            <el-input
              v-model="tableList.tableQuery.search.invoiceId"
              placeholder="请输入发票编号"
              style="width:100%"
              clearable
              @keyup.enter.native="loadTableData"
            />
          </el-col>
          <el-col :span="3">
            <el-button
              type="primary"
              @click="searchData(tableList)"
            >
              查询
            </el-button>
          </el-col>
          <el-col
            :span="3"
            style="padding-right: 20px;float: right;text-align:right;"
          >
            <el-button
              type="primary"
              @click="addFun()"
            >
              创建收款单
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <div class="table-wrap table-list-show">
        <custom-table
          :ref="tableList.tableKey"
          :table-key="tableList.tableKey"
          :data-obj="tableList"
          :table-columns="tableList.tableColumns"
          :table-data="tableList.tableData"
          :loading="tableList.tableLoading"
          :search-condition.sync="tableList.tableQuery"
          :table-custom-height="tableHeight"
          :is-paging="isPaging"
          :show-total-label="showTotalLabel"
          :is-show-total="isShowTotal"
          :total-amount="totalAmount"
          is-index-field
          is-select-field
          :data-total="tableList.tableDataTotal"
          :table-contextmenu="tableList.tableContextmenu"
          :multiple-selection.sync="multipleSelection"
          @reloadData="loadTableData(tableList)"
          @add="addFun"
          @getTotal="totalFun"
        />
      </div>

      <!-- 新增 -->
      <add-edit-dialog
        :event-type="'add'"
        :data-array="selectArray"
        :dialog-title="dialogAddEditTitle"
        :dialog-visible.sync="dialogAddEditVisible"
        @reloadData="reloadMasterData()"
      />
    </div>
  </el-dialog>
</template>
<script>
// 自定义Table
import CustomTable from '@/components/CustomTable'
// 计算表格高度，搜索，获取数据Mixin
import dialogTableCustomMixin from '@/mixin/dialogTableCustomMixin'
// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 新增
import addEditDialog from './addEditDialog'

import { loadReceivableListDataApi } from '@/api/receivable'

export default {
  name: 'ReceivableTodoReceive',
  components: { CustomTable, addEditDialog },
  mixins: [dialogDragMixin, dialogTableCustomMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    themeColor: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      tableList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'receivable_todo_receive_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: false, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            prop: 'add',
            label: '创建收款单',
            method: 'add'
          }
        ],
        tableQuery: {
          page: 1, // 页数
          limit: 50, // 每页条数
          contextmenuWrap: [], // 右键筛选字段
          sort: { // 排序对象
            prop: '', // 排序字段
            order: '' // 排序类型 ascending升序 descending降序
          },
          search: {
            projectNo: '',
            projectName: '',
            paymentUnitName: '',
            invoiceId: '',
            todoReceive: 'true'
          }
        }
      },
      multipleSelection: [],
      isPaging: true,
      isShowTotal: false,
      totalAmount: 0,
      showTotalLabel: '',
      dialogAddEditTitle: '',
      dialogAddEditVisible: false,
      selectArray: null
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.multipleSelection = []
        this.tableList.initTableColumn = [
          { prop: 'provinceName', label: '省区', filterColumn: 'r.province_name', width: 90 },
          { prop: 'cityName', label: '市场', filterColumn: 'r.city_name', width: 100 },
          { prop: 'paymentUnitName', label: '付款单位', filterColumn: 'pu.unit_name', width: 180 },
          { prop: 'receiveUnitName', label: '收款单位', filterColumn: 'ru.unit_name', width: 180 },
          { prop: 'projectNo', label: '项目编号', filterColumn: 'r.project_no', width: 200 },
          { prop: 'projectName', label: '项目名称', filterColumn: 'r.project_name', width: 150 },
          { prop: 'invoiceId', label: '发票编号', filterColumn: 'ri.invoice_id', width: 120 },
          { prop: 'quarter', label: '季度', filterColumn: 'r.quarter', width: 90 },
          { prop: 'settleAmount', label: '结算金额(不含税)', filterColumn: 'r.settle_amount', width: 150, formatPrice: true },
          { prop: 'taxAmount', label: '税额', filterColumn: 'r.tax_amount', width: 100, formatPrice: true },
          { prop: 'totalAmount', label: '应收金额', filterColumn: 'r.total_amount', width: 110, allowSum: true, formatPrice: true },
          { prop: 'receivedAmount', label: '已收金额', filterColumn: 'r.received_amount', width: 120, allowSum: true, formatPrice: true },
          { prop: 'leftAmount', label: '未收金额', filterColumn: 'r.left_amount', width: 120, allowSum: true, formatPrice: true },
          { prop: 'invoiceAmount', label: '已开票金额', filterColumn: 'r.invoice_amount', width: 120, allowSum: true, formatPrice: true },
          { prop: 'remark', label: '备注', filterColumn: 'r.remark', width: 150 }
        ]
        this.tableList.tableColumns = this.tableList.initTableColumn
        this.tableList.tableQuery.sort.order = ''
        this.tableList.tableQuery.search.projectNo = ''
        this.tableList.tableQuery.search.projectName = ''
        this.tableList.tableQuery.search.paymentUnitName = ''
        this.tableList.tableQuery.search.invoiceId = ''
        this.searchData(this.tableList)
      }
    },
    multipleSelection(val) {
      if (this.showTotalLabel === '')
        this.showTotalLabel = '未收金额'
      this.totalAmount = 0
      if (val.length > 0) {
        val.forEach(item => {
          this.totalAmount += Number(item.leftAmount)
        })
        this.totalAmount = Number(this.totalAmount.toFixed(2))
        this.isShowTotal = true
      } else {
        this.isShowTotal = false
      }
    }
  },
  methods: {
    // 请求数据
    requestData() {
      this.tableList.tableLoading = true
      loadReceivableListDataApi({ condition: JSON.stringify(this.tableList.tableQuery) }).then(response => {
        this.tableList.tableLoading = false
        let data = response.data.data || []
        this.handleData(this.tableList, data)
        this.tableList.tableDataTotal = response.data.recordsTotal || 0
      }).catch()
    },
    // 合计方法
    totalFun(fieldColumn, computedTotalObj) {
      this.tableList.tableLoading = true
      let sumCondition = { condition: JSON.stringify(this.tableList.tableQuery) }
      sumCondition.isSumTotal = true
      sumCondition.sumField = computedTotalObj.filterColumn
      loadReceivableListDataApi(sumCondition).then(response => {
        this.tableList.tableLoading = false
        this.isShowTotal = true
        this.totalAmount = response.data ? response.data.sumTotal : 0
      }).catch()
    },
    // 关闭弹框
    modalClose() {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
    },
    // 刷新列表
    reloadMasterData() {
      this.$emit('reloadData')
      this.loadTableData(this.tableList)
    },
    // 创建收款单
    addFun() {
      if (this.multipleSelection.length < 1) {
        this.$message({ message: '请选择要收款的应收款单', type: 'warning' })
        return false
      } else {
        let paymentUnitId = ''
        let receiveUnitId = ''
        let samePaymentUnit = false
        let sameReceiveUnit = false
        this.multipleSelection.forEach(item => {
          if (paymentUnitId === '') {
            paymentUnitId = item.paymentUnitId
          } else if (paymentUnitId !== item.paymentUnitId) {
            samePaymentUnit = true
          }
          if (receiveUnitId === '') {
            receiveUnitId = item.receiveUnitId
          } else if (receiveUnitId !== item.receiveUnitId) {
            sameReceiveUnit = true
          }
        })
        if (samePaymentUnit) {
          this.$message({ message: '请选择相同付款单位的应收款单', type: 'warning' })
          return false
        }
        if (sameReceiveUnit) {
          this.$message({ message: '请选择相同收款单位的应收款单', type: 'warning' })
          return false
        }

        this.selectArray = this.multipleSelection
        this.dialogAddEditTitle = '新增收款单'
        this.dialogAddEditVisible = !this.dialogAddEditVisible
      }
    }
  }
}
</script>
<style lang="scss"  scoped>
.table-wrap {
  margin-top: 5px;
}
::v-deep .total-text {
  bottom: 22px;
}
</style>
